module.exports = __webpack_public_path__ + "static/media/8.6c0b2666.svg";